import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../util/translationUtility';

const MoreButton = ({onClick}) => 
<button
        className="btn btn-neogen-light-gray"
    onClick={onClick}
    >
        {translateResourceString("/Search/LoadMore")} <span className="ml-1 custom-caret-down" />
</button>;

MoreButton.propType = {
    onClick: PropTypes.func.isRequired
};

export default MoreButton;